const commonMenu = [
  {
    "label": "company",
    "role": "company",
    "icon": "pi pi-building",
    "items": [
      {"label": "club_info", "url": "/company/info", "icon": "pi pi-info-circle"},
      {"label": "teams", "url": "/company/teams", "icon": "pi pi-users"}
    ]
  },
  {
    "label": "settings",
    "key": "settings",
    "role": "common",
    "icon": "pi pi-cog",
    "items":
      [
        {"label": "country", "url": "/settings/country", "icon": "pi pi-home"},
        {"label": "region", "url": "/settings/region", "icon": "pi pi-cog"}
      ]
  },
  {
    "label": "admin",
    "key": "admin",
    "role": "admin",
    "icon": "pi pi-crown",
    "items": [
      {"label": "dashboard", "url": "/admin", "icon": "pi pi-chart-bar"},
      {"label": "agreement", "url": "/admin/agreements", "icon": "pi pi-file-edit"},
      {"label": "companies", "url": "/admin/companies", "icon": "pi pi-box"},
      {
          "label": 'Импорт клубов',
          "icon": 'pi pi-cloud-download',
          "url": '/admin/company_imports'
      }
    ]
  }
]

export default commonMenu